/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import restClient from '../../app/helpers/restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_PAGE_CARTSERVICE = '/ext/cart';
const RESOURCE_PAGE_CARTSERIVE_EXT_PAGE = '/rewards/balance';

const getRewardBalance = ({
    wcEnv, jwtToken, cartId, creditCard, rewardAction,
    isCardTokenized, sourceApp,
}) => {
    const envObj = wcEnv || {};

    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}`;

    const resourcePage =  `${RESOURCE_PAGE_CARTSERVICE}${RESOURCE_PAGE_CARTSERIVE_EXT_PAGE}`;

    const payload = {
        cartId,
        creditCard,
        rewardAction,
        isCardTokenized,
        sourceApp,
    };

    return restClient.postFacade(envObj, resourcePage, jwtToken, payload)
        .then((response) => response);
};

export default getRewardBalance;
